// extracted by mini-css-extract-plugin
export default {"footerDark":"atFO4NlRDQqmD0DGHgBhtQ==","content":"otKCqynBceeb2w4FoAwKmQ==","shareIcon":"_6kKpOHN-wwhn4uODS6n2bQ=="};